import { Trans } from '@lingui/macro'
import { DialogContentText, Typography } from '@mui/material'
import type { EnhancedDomain } from 'sunlife-domain'

import { AttributeToggleSelector, GenericDimensionSlider } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { HelpButton } from './HelpButton'

const INSEAM_MARKS = [
  { value: -1, label: '-1"' },
  { value: 0, label: 'Standard' },
  { value: 1, label: '1"' },
]

export const ShortsProperties = (props: { entity: EnhancedDomain.$Shorts }) => {
  const { entity } = props
  return (
    <PropertyContainer.Group spacing="large">
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Inseam</Trans>
          </Typography>
        }
        action={
          <HelpButton
            title={
              <Typography>
                <Trans>Inseam</Trans>
              </Typography>
            }
          >
            <DialogContentText>
              {entity.type === 'SwimShorts' ? (
                <>
                  Our standard inseam for <b>swim shorts is 4"</b> and you may increase or decrease or your inseam in 1”
                  increments.
                </>
              ) : (
                <>
                  Our standard inseam for <b>board shorts is 6"</b> and you may increase or decrease or your inseam in
                  1” increments.
                </>
              )}
            </DialogContentText>
          </HelpButton>
        }
      >
        <div style={{ width: 'calc(100% - 16px)', paddingLeft: '8px' }}>
          <GenericDimensionSlider
            entityId={entity.id}
            instanceName="inseam"
            marks={INSEAM_MARKS}
            step={null}
            sliderOnly
          />
        </div>
      </PropertyContainer.Item>
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Fabric</Trans>
          </Typography>
        }
        action={
          <HelpButton
            title={
              <Typography>
                <Trans>Fabric</Trans>
              </Typography>
            }
          >
            <DialogContentText>
              <b>90/10 fabric</b>: 4-way moderate stretch fabric designed to give ultimate flexibility, comfort and
              aesthetic appeal with UV protection and chlorine resistance
              <br />
              <br />
              <b>96/4 fabric</b>: 2-way slight stretch fabric designed for premium drape and comfort with UV protection
              and chlorine resistance
              {/* TEMPORARY: Keep the tan-through description hidden while the fabric is unavailable.
              <br />
              <br />
              <b>Tan Through fabric</b>: patented stretch fabric engineered to allow tanning of the skin, while it
              selectively filters ultraviolet sunlight to achieve a safer result. Inside liner is required for safety
              purposes. */}
            </DialogContentText>
          </HelpButton>
        }
      >
        <AttributeToggleSelector entityId={entity.id} instanceName="fabric" columnCount={3} />
      </PropertyContainer.Item>
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Liner</Trans>
          </Typography>
        }
        action={
          <HelpButton
            title={
              <Typography>
                <Trans>Liner</Trans>
              </Typography>
            }
          >
            <DialogContentText>
              <b>Leisure liner</b>: premium 4-way slight mesh fabric engineered with just the right amount of support
              while providing perfect comfort and breathability. Designed to protect against bacteria, it’s our favorite
              undergarment option!
              <br />
              <br />
              <b>Compression liner</b>: premium 4-way slight mesh fabric engineered as a compression liner giving full
              support and designed with an accelerated evaporation technology to keep you dry and comfortable
            </DialogContentText>
          </HelpButton>
        }
      >
        <AttributeToggleSelector entityId={entity.id} instanceName="liner" columnCount={3} />
      </PropertyContainer.Item>
      <PropertyContainer.Item
        title={
          <Typography>
            <Trans>Size</Trans>
          </Typography>
        }
      >
        <AttributeToggleSelector entityId={entity.id} instanceName="size" columnCount={4} />
      </PropertyContainer.Item>
    </PropertyContainer.Group>
  )
}
